import { mapState } from 'vuex'

export const isZooming = {
  // This mixin serve us as we want our custom mouse cursor
  // to animate it's width, height when we are hovering
  // over certain elements
  data () {
    return {
      MX_isZooming: false,
      MX_isColorZooming: false
    }
  },
  computed: {
    ...mapState({
      type: state => state.cursor.type
    })
  },
  mounted () {
    this.MX_isZoom()
  },
  methods: {
    // On element (<h1>, <div>, etc) hover (@mouseover/@mouseenter) animate the
    // custom mouse cursor
    MX_isZoom (val) {
      // console.log(this.type, val, this.$route.name)
      if (this.type === 1 && val === true) {
        this.$store.commit('updateCursorType', 2)
      } else if (this.type === 2 && val === false) {
        this.$store.commit('updateCursorType', 1)
      } else if (this.type === 3 && val === true) {
        this.$store.commit('updateCursorType', 4)
      } else if (this.type === 4 && val === false) {
        this.$store.commit('updateCursorType', 3)
      }
      if (this.$route.name === 'Registration' || this.$route.name === 'Thankyou') {
        if (val) this.$store.commit('updateCursorType', 4)
        else this.$store.commit('updateCursorType', 3)
      }
      this.MX_isZooming = val
    },
    // On element (<h1>, <div>, etc) @mouseleave reverse the animation of
    // custom mouse cursor
    MX_hasZoomEffect () {
      this.$root.$on('hasZoomEffect', this.MX_isZooming)
    },
    // Currently unused, but maybe in the future
    // we would like to animate custom mouse cursor
    // color as well
    MX_isZoomColor (val) {
      this.$root.$emit('isZoomColor', val)
      this.MX_isColorZooming = val
    },
    MX_hasZoomColor () {
      this.$root.$on('hasZoomColor', this.MX_isColorZooming)
    }
  }
}
